function titleCaseWord(word: string): string {
  if (/^[A-Z]{2,}[\d./-]*$/.test(word)) return word;
  if (/^[\d./-]/.test(word)) return word;
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

/** Title-case a Puntt-generated label (rule name, role subtitle, etc.). */
export function toTitleCase(raw: string): string {
  return raw
    .split(/[_\s]+/)
    .filter(Boolean)
    .map(titleCaseWord)
    .join(" ");
}
